var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCentralizar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2657",
    transform: "translate(6.693 6.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1505",
    d: "M11.3,4.7c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6s6.6-2.9,6.6-6.6C17.9,7.7,14.9,4.7,11.3,4.7z  M11.3,15.7c-2.4,0-4.4-2-4.4-4.4s2-4.4,4.4-4.4s4.4,2,4.4,4.4C15.7,13.7,13.7,15.7,11.3,15.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1506",
    d: "M34.4,16.9h-3.3c-0.5-6.4-5.6-11.5-12-12V1.6c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1v3.3 c-6.4,0.5-11.5,5.6-12,12H1.6c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h3.3c0.5,6.4,5.6,11.5,12,12v3.3 c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1v-3.3c6.4-0.5,11.5-5.6,12-12h3.3c0.6,0,1.1-0.5,1.1-1.1 C35.5,17.4,35,16.9,34.4,16.9L34.4,16.9z M18,29c-6.1,0-11-4.9-11-11c0-6.1,4.9-11,11-11c6.1,0,11,4.9,11,11c0,0,0,0,0,0 C28.9,24,24,28.9,18,29z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCentralizar01);
export default __webpack_public_path__ + "static/media/ico-centralizar-01.6635c866e32272bd8586cabb59eacf05.svg";
export { ForwardRef as ReactComponent };